import "./HeroSection.css";

export default function HeroSection() {
  return (
    <section id="section1" className="hero-section">
      <div className="hero-bottom-group">
        <div className="hero-left">
          <h1>ATHENS</h1>
          <h1>UNCORKED</h1>
        </div>
        <div className="hero-bottom-line">
          <div className="hero-info">
            <p className="date">14TH OF DECEMBER 2025</p>
            <p className="place">PLEX – ATHENS</p>
          </div>
          <div className="tickets-area">
            <button 
              className="tickets-button" 
              onClick={() => window.open('https://reserve.edrink.gr/athensuncorked', '_blank')}
            >
              <span>TICKETS*</span>
              <span className="subtitle">*BOOK A TABLE</span>
            </button>
            <div className="ticket-prices">
              <p>Προπώληση 12€ και 20€ το VIP</p>
              <p>Γενική είσοδος 16€ και 25€ το VIP</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}